import { Descriptions } from 'antd'
import Style from '../allocationadd/allocationadd.module.scss'
import memberinfoHooks from './hooks'

const memberInfo = () => {
  const { userInfo } = memberinfoHooks()
  return (
    <div>
      <div className={Style['btnbox']}>
        <div className={Style['btn-left-box']}></div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}></div>
      </div>
      <div className={Style['container']}>
        <div className={Style['member-info']}>
          <Descriptions title="个人信息" column={1}>
            <Descriptions.Item label="姓名">
              {userInfo.realName}
            </Descriptions.Item>
            <Descriptions.Item label="手机号">
              {userInfo.phone}
            </Descriptions.Item>
            <Descriptions.Item label="邮箱">{userInfo.mail}</Descriptions.Item>
          </Descriptions>
        </div>
      </div>
    </div>
  )
}

export default memberInfo
import { Descriptions } from 'antd'
import Style from '../allocationadd/allocationadd.module.scss'
import memberinfoHooks from './hooks'

const memberInfo = () => {
  const { userInfo } = memberinfoHooks()
  return (
    <div>
      <div className={Style['btnbox']}>
        <div className={Style['btn-left-box']}></div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}></div>
      </div>
      <div className={Style['container']}>
        <div className={Style['member-info']}>
          <Descriptions title="个人信息" column={1}>
            <Descriptions.Item label="姓名">
              {userInfo.realName}
            </Descriptions.Item>
            <Descriptions.Item label="手机号">
              {userInfo.phone}
            </Descriptions.Item>
            <Descriptions.Item label="邮箱">{userInfo.mail}</Descriptions.Item>
          </Descriptions>
        </div>
      </div>
    </div>
  )
}

export default memberInfo
